export function replaceNewLinesWithBreaks(inputString: string): string {
    inputString = inputString.replace(/\r\n/g, '<br />');
    inputString = inputString.replace(/\\r/g, '');
    inputString = inputString.replace(/\r/g, '');
    inputString = inputString.replace(/\n/g, '<br />');
    inputString = inputString.replace(/\\n/g, '<br />');

    return inputString;
}
